import type { Scenario } from "../types";

function normalizedIdentity(value: string | undefined): string {
  return (value ?? "").trim().toLowerCase().replace(/\s+/g, " ");
}

/** A saved scenario is comparable only when it belongs to the active project.
 * Site IDs are authoritative when both scenarios carry one; legacy scenarios
 * fall back to project name + address. */
export function isSameProjectScenario(
  active: Scenario,
  candidate: Scenario,
): boolean {
  if (active.id === candidate.id) return true;
  if (active.siteId && candidate.siteId) {
    return active.siteId === candidate.siteId;
  }
  return (
    normalizedIdentity(active.assumptions.projectName) ===
      normalizedIdentity(candidate.assumptions.projectName) &&
    normalizedIdentity(active.assumptions.address) ===
      normalizedIdentity(candidate.assumptions.address)
  );
}

/** Active-first, de-duplicated comparison set for Board artifacts. */
export function sameProjectScenarios(
  active: Scenario,
  candidates: readonly Scenario[],
): Scenario[] {
  return [
    active,
    ...candidates.filter(
      (candidate) =>
        candidate.id !== active.id && isSameProjectScenario(active, candidate),
    ),
  ].filter(
    (candidate, index, list) =>
      list.findIndex((item) => item.id === candidate.id) === index,
  );
}
